import { refundAmount } from '../../../api/userAPI';

export const getRefundAmount = async (data) => {
    try {
        const response = await refundAmount(data);
        return response.data;
    } catch (error) {
        console.error('Error fetching refund amount:', error);
        throw error;
    }
};
